// Detects that a newer build has been deployed while the app is open.
// CRA fingerprints the main bundle (static/js/main.<hash>.js, static/css/main.<hash>.css), so the
// deployed index.html names different files after any code change. We fetch it fresh and compare with
// the files this page was loaded with. No version numbers or build steps to maintain.

const BUNDLE_SELECTOR = 'script[src*="/static/js/main."], link[rel="stylesheet"][href*="/static/css/main."]';

const bundleKey = (doc) =>
  [...doc.querySelectorAll(BUNDLE_SELECTOR)]
    .map((el) => el.getAttribute("src") || el.getAttribute("href"))
    .sort()
    .join("|");

// Only production builds have fingerprinted bundles (the dev server serves /static/js/bundle.js).
export const updateChecksEnabled = () => process.env.NODE_ENV === "production" && Boolean(bundleKey(document));

export async function isNewVersionAvailable() {
  const current = bundleKey(document);
  if (!current) return false;
  // "/" rather than "/index.html": the service worker serves /index.html from its cache, while other
  // non-navigation requests go straight to the network. no-store skips the HTTP cache too.
  const res = await fetch(`${process.env.PUBLIC_URL || ""}/?v=${Date.now()}`, { cache: "no-store", credentials: "same-origin" });
  if (!res.ok) return false;
  const html = await res.text();
  const latest = bundleKey(new DOMParser().parseFromString(html, "text/html"));
  return Boolean(latest) && latest !== current;
}
